module.exports = __webpack_public_path__ + "static/media/wechat_icon_transparente.a646d697.png";